// import { showErrorPopup, translateError } from "@components/ErrorHandling";
import { fetchData } from "../../Helpers";

export function registerDevice({ payload, successCallback, errorCallback }) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/device/register",
    payload: payload,
    successCallback: successCallback,
    errorCallback: errorCallback,
    controller: controller,
    shouldThrowError: false,
  });
}
